'use client'

import { useState, type ReactNode } from 'react'
import { SectionLabel } from './SectionLabel'
import { ChevronIcon } from '../icons/ChevronIcon'

interface CollapsibleSectionProps {
  label: string
  defaultOpen?: boolean
  children: ReactNode
  'data-part'?: string
  'aria-label'?: string
}

export function CollapsibleSection({
  label,
  defaultOpen = true,
  children,
  ...props
}: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <section data-component="CollapsibleSection" {...props}>
      <button
        data-part="section-toggle"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="w-full flex items-center justify-between gap-3 mb-0 text-left
          hover:opacity-80 transition-opacity"
      >
        <SectionLabel>{label}</SectionLabel>
        <ChevronIcon
          className={`shrink-0 text-mist dark:text-cream/30 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
        />
      </button>
      {open && children}
    </section>
  )
}
